import { render, staticRenderFns } from "./search.module.vue?vue&type=template&id=2f5772c3&scoped=true"
import script from "./search.module.vue?vue&type=script&lang=js"
export * from "./search.module.vue?vue&type=script&lang=js"
import style0 from "./search.module.vue?vue&type=style&index=0&id=2f5772c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5772c3",
  null
  
)

export default component.exports